import clsx from 'clsx'

import { ROLE_FACILITATOR, ROLE_PARTICIPANT } from '../constants'

const AdminListItem = ({ email = '', role = '', onSelectRole = undefined }) => {
  // Don't render anything if not enough info provided
  if (email.length === 0) {
    return null
  }

  return (
    <tr className="border-b-[1px] border-b-light-gray last-of-type:border-b-0">
      <td className="w-full px-2 py-4">{email}</td>
      {role !== '' && (
        <td>
          {onSelectRole ? (
            <div className="flex items-center justify-center">
              <button
                className={clsx(
                  'mr-1 select-none rounded-[10px] border-2 px-4 py-1',
                  role === ROLE_FACILITATOR
                    ? 'border-flame bg-flame text-white'
                    : 'border-light-gray text-dark-gray',
                  !onSelectRole && 'cursor-not-allowed'
                )}
                onClick={
                  onSelectRole ? onSelectRole(email, ROLE_FACILITATOR) : null
                }
              >
                Facilitator
              </button>
              <button
                className={clsx(
                  'select-none rounded-[10px] border-2 px-4 py-1',
                  role === ROLE_PARTICIPANT
                    ? 'border-flame bg-flame text-white'
                    : 'border-light-gray text-dark-gray',
                  !onSelectRole && 'cursor-not-allowed'
                )}
                onClick={
                  onSelectRole ? onSelectRole(email, ROLE_PARTICIPANT) : null
                }
              >
                Participant
              </button>
            </div>
          ) : (
            <div className="flex items-center justify-center">
              <span
                className={clsx(
                  'mr-1 select-none rounded-[10px] border-2 px-4 py-1',
                  role === ROLE_FACILITATOR
                    ? 'border-flame bg-flame text-white'
                    : 'border-light-gray text-dark-gray',
                  !onSelectRole && 'cursor-not-allowed'
                )}
                onClick={
                  onSelectRole ? onSelectRole(email, ROLE_FACILITATOR) : null
                }
              >
                Facilitator
              </span>
              <span
                className={clsx(
                  'select-none rounded-[10px] border-2 px-4 py-1',
                  role === ROLE_PARTICIPANT
                    ? 'border-flame bg-flame text-white'
                    : 'border-light-gray text-dark-gray',
                  !onSelectRole && 'cursor-not-allowed'
                )}
                onClick={
                  onSelectRole ? onSelectRole(email, ROLE_PARTICIPANT) : null
                }
              >
                Participant
              </span>
            </div>
          )}
        </td>
      )}
    </tr>
  )
}

export default AdminListItem
